import { ClassRouteImport } from './Import'
const { RoutesMap, ClassList } = ClassRouteImport

const ClassRoute = () => {
    return [
        {
            path: RoutesMap.CLASS_LIST.path,
            element: <ClassList />
        },
    ]
}

export default ClassRoute;
